"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantRatingsUpdateSchema = exports.MerchantRatingsUpdateScalarSchema = exports.MerchantRatingsCreateSchema = exports.MerchantRatingsCreateScalarSchema = exports.MerchantRatingsPrismaUpdateSchema = exports.MerchantRatingsPrismaCreateSchema = exports.MerchantRatingsSchema = exports.MerchantRatingsScalarSchema = void 0;
// @ts-nocheck
const zod_1 = require("zod");
const baseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    rating: zod_1.z.number().gte(0).lte(5).default(0),
    comment: zod_1.z.string().max(1000, { message: "Comment must be between 0 and 1000 characters" }).nullish(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date(),
}).strict();
const relationSchema = zod_1.z.object({
    merchant: zod_1.z.record(zod_1.z.unknown()),
    customer: zod_1.z.record(zod_1.z.unknown()),
});
const fkSchema = zod_1.z.object({
    merchantId: zod_1.z.string().uuid(),
    customerId: zod_1.z.string().uuid(),
});
/**
 * `MerchantRatings` schema excluding foreign keys and relations.
 */
exports.MerchantRatingsScalarSchema = baseSchema;
/**
 * `MerchantRatings` schema including all fields (scalar, foreign key, and relations) and validations.
 */
exports.MerchantRatingsSchema = exports.MerchantRatingsScalarSchema.merge(fkSchema).merge(relationSchema.partial());
/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
exports.MerchantRatingsPrismaCreateSchema = baseSchema.partial().passthrough();
/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
exports.MerchantRatingsPrismaUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    rating: zod_1.z.union([zod_1.z.number().gte(0).lte(5).default(0), zod_1.z.record(zod_1.z.unknown())]),
    comment: zod_1.z.string().max(1000, { message: "Comment must be between 0 and 1000 characters" }).nullish(),
    createdAt: zod_1.z.coerce.date().default(() => new Date()),
    updatedAt: zod_1.z.coerce.date()
}).partial().passthrough();
/**
 * `MerchantRatings` schema for create operations excluding foreign keys and relations.
 */
exports.MerchantRatingsCreateScalarSchema = baseSchema.partial({
    rating: true, createdAt: true, updatedAt: true
});
/**
 * `MerchantRatings` schema for create operations including scalar fields, foreign key fields, and validations.
 */
exports.MerchantRatingsCreateSchema = exports.MerchantRatingsCreateScalarSchema.merge(fkSchema);
/**
 * `MerchantRatings` schema for update operations excluding foreign keys and relations.
 */
exports.MerchantRatingsUpdateScalarSchema = baseSchema.partial();
/**
 * `MerchantRatings` schema for update operations including scalar fields, foreign key fields, and validations.
 */
exports.MerchantRatingsUpdateSchema = exports.MerchantRatingsUpdateScalarSchema.merge(fkSchema.partial());
